// Pure helpers for the "coin" / perforated circular border generator. The
// milled coin edge is drawn with a repeating-conic-gradient masked to a ring.
// Browser-local, no dependencies.

export interface CoinBorderState {
  size: number;
  faceColor: string;
  dashColor: string;
  dashCount: number;
  ringThickness: number;
}

export const DEFAULT_COIN_BORDER_STATE: CoinBorderState = {
  size: 200,
  faceColor: '#f2c14e',
  dashColor: '#c9971f',
  dashCount: 40,
  ringThickness: 14,
};

export function coinBorderCss(state: CoinBorderState, className = 'coin'): string {
  const count = Math.max(4, Math.round(state.dashCount));
  const step = 360 / count;
  const half = (step / 2).toFixed(3);
  const full = step.toFixed(3);
  const inner = state.size;
  const outer = state.size + state.ringThickness * 2;
  return `.${className} {
  position: relative;
  width: ${inner}px;
  height: ${inner}px;
  border-radius: 50%;
  background: ${state.faceColor};
}

.${className}::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${outer}px;
  height: ${outer}px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: repeating-conic-gradient(
    ${state.dashColor} 0deg ${half}deg,
    transparent ${half}deg ${full}deg
  );
  -webkit-mask: radial-gradient(
    farthest-side,
    transparent calc(100% - ${state.ringThickness}px),
    #000 calc(100% - ${state.ringThickness}px)
  );
  mask: radial-gradient(
    farthest-side,
    transparent calc(100% - ${state.ringThickness}px),
    #000 calc(100% - ${state.ringThickness}px)
  );
  z-index: -1;
}`;
}

export function coinBorderHtml(className = 'coin'): string {
  return `<div class="${className}"></div>`;
}

export function coinBorderSnippet(state: CoinBorderState): string {
  return `${coinBorderHtml()}\n\n<style>\n${coinBorderCss(state)}\n</style>`;
}
